import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/rockrms': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM405.4 427.5l-101.5-118.9s73.6-0.2 74.2-0.2c29.6 1.1 46.6-33.3 27.6-56.1l-157.7-185.1c-13.2-17.3-40.1-18.4-54.5 0l-147.1 172.5h90l84.3-98.9 84.6 99.3h-75.3c-30.5 0-44.5 35.7-26.6 56.1l112 131.3h90z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/rockrms.js
// module id = 1001
// module chunks = 0